import { useEffect, useContext, useRef } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Switch, Stack } from '@mui/material';
import { env } from '../../../../core/Env';
import { rqx } from '../../../../core/request/API';
import { ToolContext } from '../../../../core/context/ToolContext';
import { SnakeLoader } from '../../../../core/loader/SnakeLoader';
import { useHistory }  from 'react-router-dom';
import { Forms } from './forms/Index';
import { Waypoint } from "react-waypoint";
import { BorderColor as BorderColorIcon } from '@mui/icons-material';
import { EmptyList, Confirmation } from '../../../../core/global/realproperty/Index';
import { SuccessMsg } from '../../../../core/global/SuccessMsg';

export const RequestedListing = ({ method }) => {
    const { realproperty_state, tool_state } = useContext(ToolContext);
    const { rqstdLstng, types, confirmation, status } = realproperty_state;
    const company_id = tool_state.__SESSION.data.uaccess[0].company_id;
    const user_id = Number(window.atob(tool_state.__SESSION.data.ainfo.aid).split('_').pop());
    const nav = useHistory();
    const tab = new URLSearchParams(window.location.search).get('tab')
    const topRef = useRef(null);
    // to auto scroll at the top when one of the component tabs mount
    useEffect(() => {
        if (tab) {
            topRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [tab])
    // for infinite scroll states (other way of infinite scroll implementaion)
    const __init = async (val) => {
        if (val === 0) {
            rqstdLstng.set((p) => ({ ...p, loader: true,  rqstdLstngInftScroll: true })) 
        }
        rqstdLstng.set((p) => ({ ...p, rqstdLstngIsLoading: true }))
        const res_list = await rqx.get(`<<tool>>/${env()}/propertyListing/read_requested_listing`, { 
            lastId: val,
            limit: 15,
            comp_id: company_id
        })
        if (res_list) {
            const last_id = res_list.length > 0 ? res_list[res_list.length - 1].id : val;
            rqstdLstng.set((p) => ({ ...p, rqstdLstngLastId: last_id })) 
            if (val === 0 || val === undefined || val === "") {
                rqstdLstng.set((p) => ({ ...p, list: res_list })) 
            } else {
                rqstdLstng.set((p) => ({ ...p, list: [...p.list, ...res_list] })) 
            }
            if (res_list.length < 15) {
                rqstdLstng.set((p) => ({ ...p, rqstdLstngInftScroll: false, rqstdLstngHasMore: false })) 
            }
        }
        rqstdLstng.set((p) => ({ ...p, rqstdLstngIsLoading: false, loader: false })) 
    };

    const loadMoreData = async () => {
        if (rqstdLstng.data.rqstdLstngCooldown || rqstdLstng.data.rqstdLstngIsLoading || !rqstdLstng.data.rqstdLstngHasMore) return;
        rqstdLstng.set((p) => ({ ...p, rqstdLstngCooldown: true })) 
        await __init(rqstdLstng.data.rqstdLstngLastId);
        setTimeout(() => rqstdLstng.set((p) => ({ ...p, rqstdLstngCooldown: false })) , 500);
    };

    useEffect(() => {
        rqstdLstng.set((p) => ({
            ...p,
            list: [],
            loader: true,
            rqstdLstngInftScroll: true,
            rqstdLstngIsLoading: false,
            rqstdLstngCooldown: false,
            rqstdLstngHasMore: true,
            rqstdLstngLastId: 0,
        }))
        const getTypes = async () => {
            const res_property_types = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "property_type" });
            const res_all_sub_types = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "all_property_subtype" });
            if (res_property_types && res_all_sub_types) {
                types.set((p) => ({
                    ...p,
                    propertyTypes: res_property_types,
                    allPropertySubTypes: res_all_sub_types,
                }));
            }
            __init(0);
        };
        getTypes();
        // eslint-disable-next-line
    }, []);

    const toUpdate = (id) => {
        nav.push(`${window.location.pathname}?method=update&tab=main-information&pkey=${window.btoa(`prm_${id}`)}`)
    }

    const handleStatusModal = (v, active, id) => {
        confirmation.set((p) => ({ ...p, statusConfirmation: v === 'open' }))
        status.set((p) => ({...p, statusId: id, statusData: active }))
    }

    const handleUpdateStatus = async () => {
        confirmation.set((p) => ({ ...p, statusLoader: true }))
        try {
            const body = {
                id: status.data.statusId,
                userId: user_id,
                active: status.data.statusData === 1 ? 0 : 1
            }
            const res = await rqx.post(`<<tool>>/${env()}/propertyListing/update_status_requested_listing`, body)
            if (res.message === 'success') {
                status.set((p) => ({...p, isStatusUpdated: true }))
                rqstdLstng.set((p) => ({ 
                    ...p, list: p.list.map(v => v.id === status.data.statusId ? { ...v, active: status.data.statusData === 1 ? 0 : 1} : v)
                }))
                confirmation.set((p) => ({ ...p, statusLoader: false, statusConfirmation: false }))
            }
        } catch (err) {
            console.error("Failed to update status", err);
        } 
    }

    return (
        <Box pt="1rem" ref={topRef}>
            { method === 'update' ?
                <Forms company_id={company_id} user_id={user_id}/>
            :
                rqstdLstng.data.loader ?  
                    <Box display="flex" justifyContent="center" mt="4rem"><SnakeLoader size="12px" bg="#11783C" distance="8px" /></Box>
                :
                    rqstdLstng.data.list.length === 0?
                        <EmptyList text="No property listings have been requested at this time."/>
                    :
                        <>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 700 }}>
                                    <TableHead sx={(theme) => ({ bgcolor: theme.palette.primary.main })}>
                                        <TableRow>
                                            <TableCell align="center" sx={{ color: "white", width: "4rem", }}>No.</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Property Type</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Property Sub-type</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Offer type</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Contact No.</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Details Status</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Status</TableCell>
                                            <TableCell align="center" sx={{ color: "white", width: "6rem" }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {rqstdLstng.data.list?.map((v, k) => (
                                        <TableRow key={k}>
                                            <TableCell component="th" scope="row" align="center"> 
                                                {rqstdLstng.data.list.length - k}
                                            </TableCell>
                                            <TableCell align="left">{types.data.propertyTypes?.find(p => p.id === v.property_type_id)?.name}</TableCell>
                                            <TableCell align="left">{types.data.allPropertySubTypes?.find(p => p.id === v.property_subtype_id)?.name}</TableCell>
                                            <TableCell align="left">{v.offer_type === 1 ? "Sell" : v.offer_type === 2 ? "Rent" : "Unknown Offer Type"}</TableCell>
                                            <TableCell align="left">{v.phone_number}</TableCell>
                                            <TableCell align="left">
                                                {<Box px="0.5rem" sx={{ borderRadius: "8px", width: "fit-content",
                                                    bgcolor: v.listing_detail_status === 1 ? "#FFF4E5" : v.listing_detail_status === 2 ? "#E3F2FD" : v.listing_detail_status === 3 ? "#F3E5F5" : "grey", 
                                                    color: v.listing_detail_status === 1 ? "#B26A00" : v.listing_detail_status === 2 ? "#1565C0" : v.listing_detail_status === 3 ? "#6A1B9A" : "black" }}>
                                                    { v.listing_detail_status === 1 ? "For Review" : v.listing_detail_status === 2 ? "For Ocular" : v.listing_detail_status === 3 ? "For Details Completion" : "Unknown Status"}
                                                </Box>}
                                            </TableCell>
                                            <TableCell align="left">
                                                {<Box px="0.5rem" sx={{ borderRadius: "8px", width: "fit-content",
                                                    bgcolor: v.status === 1 ? "#2e7d324D" : v.status === 2 ? "#1976d24D" : v.status === 3 ? "#d32f2f4D" : "grey", 
                                                    color: v.status === 1 ? "#2e7d32" : v.status === 2 ? "#1976d2" : v.status === 3 ? "#d32f2f" : "black" }}>
                                                    {v.status === 1 ? "Saved" : v.status === 2 ? "Published" : v.status === 3 ? "Sold" : "Unknown Status"}
                                                </Box>}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
                                                    <BorderColorIcon onClick={() => toUpdate(v.id)}fontSize="small" sx={{ cursor: "pointer", transition: "0.25s" ,':hover': { color: "grey" } }}/>
                                                    <Switch disabled={ v.status === 3 } onClick={() => handleStatusModal('open', v.active, v.id)} size="small" checked={v.active === 1}/>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            { confirmation.data.statusConfirmation && <Confirmation isOpen={confirmation.data.statusConfirmation} cancel={() => handleStatusModal('close')} send={() => handleUpdateStatus()} disabled={confirmation.data.statusLoader} status={status.data.statusData} dsbldTxt={ <> This property is currently listed on <b>POFShop</b> and is visible to potential clients. Disabling it will remove the property from public view on <b>POFShop</b>, but it will remain in a published status within your listing. </> } enbldTxt={ <> This property is currently published but not visible on <b>POFShop</b>. Enabling it will make the listing publicly accessible again to potential clients. You can continue to make updates even after it is enabled. </>}/> }
                            {rqstdLstng.data.rqstdLstngInftScroll && rqstdLstng.data.rqstdLstngHasMore && (
                                <Box sx={{ mt: "2rem" }}>
                                    <Waypoint onEnter={loadMoreData}>
                                        <Box display="flex" justifyContent="center" my={2}>
                                            <SnakeLoader
                                                bg="#11783C"
                                                size="12px"
                                                distance="8px"
                                            />
                                        </Box>
                                    </Waypoint>
                                </Box>
                            )}
                        </>
            }
            { status.data.isStatusUpdated && <SuccessMsg open={status.data.isStatusUpdated} setOpen={(v) => status.set(p => ({ ...p, isStatusUpdated: v }))} message="Success" bgcolor="#d2f9e2" hideDuration={2000}/> }
        </Box>
    )
}
